import { z } from 'zod';
import { shipTermsFormSchema } from './create-form.js';
export const createShipTermsInputSchema = shipTermsFormSchema.extend({
    makeDefault: z.boolean().optional(),
});
//# sourceMappingURL=create-input.js.map